import React, { useState } from 'react'
import { ContainerGallery } from '../../styles/styles';
import "../TabMenu/tab.css";
import Menu from "./menu";
import { buildProductWhatsAppMessage, buildWhatsAppLink } from '../../utils/whatsapp';

const categories = [
    "Todos",
    "Recarga Extintores",
    "Extintores",
    "Rede de Hidrante",
    "Sinalização Extintores",
    "Placa Rota Fuga",
    "Suporte para Extintores",
] as const;

type ProductCategory = (typeof categories)[number];

function GalleryReact() {

    const [items, setItems] = useState(Menu);
    const [isCategorySelected, setIsCategorySelected] =
        useState<ProductCategory>("Todos");

    const filterItem = (category: ProductCategory) => {
        setIsCategorySelected(category);

        if (category === "Todos") {
            setItems(Menu);
            return;
        }

        const updatedItems = Menu.filter((item) => item.category === category);
        setItems(updatedItems);
    };


    return (
        <ContainerGallery
            id="produtos"
            whileInView="visible"
            initial="initial"
            viewport={{ once: true }}
            variants={{
            initial: { opacity: 0, y: 10 },
            visible: {
                opacity: 1,
                y: 0,
                transition: { duration: 1, delay: 0.3 },
            },
            }}
            className="products-section"
        >
            <div className="products-container">
                <h1 className="products-title">PRODUTOS</h1>

                <div className="products-filters" role="tablist" aria-label="Categorias de produtos">
                    {categories.map((category) => (
                        <button
                            key={category}
                            type="button"
                            className={`products-filter-btn ${isCategorySelected === category ? "is-active" : ""}`}
                            onClick={() => filterItem(category)}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                <div className="products-grid">
                    {items.map((item) => {
                        const { id, name, image, description } = item;
                        const productWhatsappLink = buildWhatsAppLink(
                            buildProductWhatsAppMessage(name)
                        );

                        return (
                            <article className="product-card" key={id}>
                                <div className="product-media">
                                    <img src={image} alt={name} loading="lazy" />
                                </div>

                                <div className="product-content">
                                    <h2>{name}</h2>
                                    <p>{description}</p>
                                    <a href={productWhatsappLink} className="product-cta">
                                        Solicitar Orçamento
                                    </a>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </ContainerGallery>
    )
}

export default GalleryReact;
